import styled from "styled-components";

export const MarketingCTALinkCard = styled.div<{ useHover?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
    box-shadow: ${({ useHover }) => useHover ? undefined : "0px 6px 20px rgba(0, 0, 0, 0.1);"};
    border-radius: 30px;
    padding: 18px;
    text-align: center;
    border: ${({ theme, useHover }) => useHover ? `1px solid ${theme.v3.colors.grey88}` : undefined};

    &:hover {
        text-decoration: underline;
        box-shadow: ${({ useHover }) => useHover ? "0px 6px 20px rgba(0, 0, 0, 0.1);" : undefined};
        cursor: pointer;
    }
`;